import React from "react";
import "./style.scss";
import logo from "../../assets/images/svgs/newLogo.svg";
import { getToken, removeToken } from "../../functions/localStorage";
import Textbtn from "../buttons/textbtn";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../assets/icons/Icons";
import RoundedBtn from "../buttons/roundedBtn";
import hamburgerIcon from "../../assets/images/svgs/hamburger.svg";

const Navbar = ({
  showBack,
  onBack,
  showLocationBtn,
  hamburger,
  handleOpenDrawer,
  locationBtnText,
  locationClick
}) => {
  const navigate = useNavigate();
  const isLoggedIn = getToken();

  const logout = () => {
    removeToken();
    navigate("/login");
  };

  const gotoLocation = () => navigate("/location");

  return (
    <div className="navbar__main">
      <div className="w-25 align-items-center nav__back__btn__section gap-3">
        {hamburger ? (
          <div className="hamburger__icon__tablet">
            <Textbtn
              onClick={handleOpenDrawer}
              text={<img src={hamburgerIcon} alt="" />}
            />
          </div>
        ) : (
          ""
        )}
        {showLocationBtn ? (
          <RoundedBtn
            onClick={locationClick ?? gotoLocation}
            text={locationBtnText ?? "Main Page"}
          />
        ) : (
          ""
        )}
        {showBack ? <Textbtn onClick={onBack} text={<BackIcon />} /> : ""}
      </div>
      <div className="w-50 d-flex justify-content-center gap-3 align-items-center">
        {hamburger ? (
          <div className="hamburger__icon">
            <Textbtn
              onClick={handleOpenDrawer}
              text={<img src={hamburgerIcon} alt="" />}
            />
          </div>
        ) : (
          ""
        )}
        <img src={logo} alt="" />
      </div>
      <div className="w-25 d-flex justify-content-end align-items-center">
        {isLoggedIn ? <Textbtn onClick={logout} text={"LOGOUT"} /> : ""}
      </div>
    </div>
  );
};

export default Navbar;
